import React, { Component } from 'react'

// Externals
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Typography, withStyles } from '@material-ui/core'
import { Paper } from 'components'
import styles from './styles'

class AnalyticsStatus extends Component {
  render () {
    const { classes, className, details, ...rest } = this.props

    const rootClassName = classNames(classes.root, className)

    return (
      <Paper
        {...rest}
        className={rootClassName}
      >
        <div className={classes.content}>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
              Overview
            </Typography>
          </div>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
                Carts Created
            </Typography>
            <Typography
              className={classes.value}
              variant='body2'
            >{details.carts_created}
            </Typography>
          </div>

          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
                Orders Completed
            </Typography>
            <Typography
              className={classes.value}
              variant='body2'
            >{details.orders_made}
            </Typography>
          </div>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
                Shop Details
            </Typography>
            <Typography
              className={classes.value}
              variant='body2'
            >{details.shop_details}
            </Typography>
          </div>
          {/* </div> */}
        </div>
      </Paper>
    )
  }
}

AnalyticsStatus.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(AnalyticsStatus)
